export enum GsnWeb3ProviderState {
  PENDING,
  READY,
  FAIL,
}
